import { Box, Heading, Paragraph } from 'grommet';
import React from 'react';

const Forbidden = () => (
  <Box fill align="center" justify="center">
    <Heading> Ingen tilgang desverre </Heading>
    <Paragraph>Ta kontakt med en admin hvis dette er feil.</Paragraph>
  </Box>
);

export default Forbidden;
